import { useQuery } from "@tanstack/react-query";
import axiosManager from "../services/axiosManager";
import { getVerificationStatusKeyAndFlag } from "../utils/getVerificationStatusKey";

export const useGetStudentVerificationStatus = (studentId, enabled) => {
    const {
        isLoading, data, error,
        refetch, isRefetching,
    } = useQuery({
        queryKey: [`student/${studentId}/VerificationStatus`],
        queryFn: () => axiosManager.get$(`/parent/api/students/${studentId}/VerificationStatus`).then((response) => response?.data),
        retry: 0,
        cacheTime: 0,
        enabled: enabled && !!studentId,
    });

    const studentVerificationStatus = data || {};

    return {
        isLoading,
        isRefetching,
        studentVerificationStatus,
        studentVerificationKey: getVerificationStatusKeyAndFlag(studentVerificationStatus, true),
        error,
        refetch,
    };
};
